export default __webpack_public_path__ + "static/media/paw_effect.8b79d2bc.wav";